import PrivacyPolicyLink from '../../Components/PrivacyPolicyLink'

export const termsAndConditions = (dialog) => [
  {
    variant: 'h5',
    component: 'div',
    color: 'primary',
    text: 'REDX LEGAL TERMS AND CONDITIONS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Welcome to the REDX website (the "Site").'
  },
  {
    variant: 'p',
    component: 'b',
    text: 'PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Wherever used herein, "REDX CORP." means REDX CORP. (referred to as "REDX CORP.", "we", "us", or "our" herein) and the "REDX CORP. Group" means REDX CORP. and includes REDX CORP.\'s related or affiliated entities, suppliers and licensors, and their respective directors, officers, representatives, employees, consultants and agents. "Affiliate" as to any entity shall mean any other entity that directly, or indirectly through one or more intermediaries, controls, or is controlled by, or is under common control with, such entity.The term "control" (including, with correlative meanings, the terms "controlled by" and "under common control with" as used with respect to any entity) means the possession, directly or indirectly, of the power to direct, or cause the direction of, the management and policies of such entity whether through ownership of voting securities, by contract or otherwise.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'By accessing, browsing and using this Site and the content, products and services offered thereon, you and your Users (as defined below) are signifying consent to be bound by this Agreement. If you or your Users do not agree to these Legal Terms and Conditions, please exit this Site and cease all use of the content, products and services offered on the Site.'
  },
  {
    variant: 'h6',
    component: 'div',
    text: '1 GENERAL TERMS FOR THE SITE AND CONTENT'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.1 BECOMING A SUBSCRIBER TO THE REDX SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'A complete application for the Real Estate Data Exchange service (the "REDX Service") is comprised of the application form together with Pricing and any other appendices approved in writing by you and us from time to time and attached thereto (collectively, the "REDX Application"). The REDX Application form as approved by REDX CORP. from time to time may be posted on the Site. See Section 5.1 and Section 5.2 below for the current REDX Services available and the additional Application information required for the REDX Non-Public Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '"Pricing" means the REDX pricing with fees and payment methods approved by REDX CORP., which pricing may be a separate document attached to or incorporated into the REDX Application.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '"Agreement" means a combination of these Legal Terms and Conditions, the completed REDX Application with Pricing, which Application has been signed by you and approved by REDX CORP.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The words "you" and "your" means the subscriber identified on the REDX Application (the "Subscriber"). "User" means an employee of the Subscriber that is designated by you on the REDX Application, which User may access, browse and use the Site and the Content on your behalf using your "Subscriber IDs" and their "User Name" and "User Password" which is initially issued by REDX CORP. and may be changed by the User.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You may subscribe for multiple accounts (each a " REDX Account") for access to and use of the REDX Service for the Subscription Period (as defined in Section 1.12) by completing and signing the REDX Application and delivering the REDX Application and required payments to REDX CORP. By signing the REDX Application, you acknowledge that you and your Users have read and understand these Legal Terms and Conditions and the applicable REDX Policies and Procedures Guides, as amended from time to time, including the policies, procedures, and other material contained therein and the sections dealing with compliance with laws.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Your REDX Application is subject to our acceptance. On approval of your REDX Application, REDX CORP. will issue your Subscriber IDs for your Subscribers and the User Name and the initial User Password for each of the listed Users.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.2 RESTRICTIONS ON USE OF THE SITE AND CONTENT'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.2.1 REDX CORP. Service'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'This Site is a service of REDX CORP. and is controlled and operated by REDX CORP. All content included on this Site, including but not limited to the REDX Service which includes REDX Information, REDX Products and Documentation (all as defined in Section 2.1), Software (as defined below), text, graphics, logos, button icons, images, audio and video clips, materials, information, products or services contained thereon, and software (collectively, "Content") is the property of REDX CORP., or other parties that have licensed their materials to REDX CORP., and is protected by Canadian and international copyright laws.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.2.2 Internal Business Purposes'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Unless otherwise expressly stated, no Content from this Site or any website owned, operated, licensed or controlled by REDX CORP. may be copied, reproduced, republished, uploaded, posted, transmitted, framed, commercially exploited or distributed in any way or by any means whatsoever and can only be used for your personal, internal business use only, provided all copyright and other proprietary notices are maintained. "Internal Business Purposes" means only your internal business processes, activities, operations and administration. Modification of the Content or use of the Content for any other purpose other than Internal Business Purposes (including use of any such material on any other website or networked computer environment) is a violation of copyright and other proprietary rights. You and your Users agree to abide by all copyright notices, information and restrictions contained in the Content on or accessed through the Site.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.2.3 Software Licence'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'In the event your Users download Software from the Site, the Software, including any documentation, files, images incorporated in or generated by the Software and data accompanying the Software (collectively, "Software") are licensed to you by REDX CORP. solely for the Subscription Period. Your license to use the Software is personal, non-exclusive, non-transferable and non-assignable. Title to the Software is not being transferred to you. You own the medium on which the Software is recorded but REDX CORP., or others, retain full and complete copyright in and title to the Software and all other intellectual property rights therein. You and your Users may not redistribute, sell, decompile, reverse-engineer or disassemble the Software.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.2.4 Documentation Licence During Evaluation'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Certain REDX Documentation may be available to you for evaluation purposes prior to our acceptance of your REDX Application with Pricing. "Evaluation" means that Documentation may be used solely by you in your evaluation of the suitability of the Site, the Content and other relevant factors as part of your determination whether you will become a Subscriber to the REDX Service. If we provide you with REDX Documentation prior to your completion of the REDX Application and our acceptance of same, we grant to you a non-exclusive, non-transferable, limited personal licence to use such Documentation for Evaluation purposes only in accordance with the terms and conditions of this Agreement for a period of thirty days (30) days from the date you download or receive a copy of the Documentation. During Evaluation you may not, except with REDX CORP.\'s prior written consent:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>Make any other use of the Documentation;</li><li>Rent, lease, assign or transfer your use of the Documentation;</li><li>Allow any other person to access the Documentation;</li><li>Distribute copies of the Documentation;</li><li>Copy, reproduce or incorporate the Documentation into a database or other product; or</li><li>Transmit any part of the Documentation in any form or by any means.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You shall take all reasonable precautions to keep the Documentation from being used or acquired by any person or persons except your employees, agents and representatives who have a "need to know" same. You acknowledge that the Documentation is a proprietary copyrighted work(s) of REDX CORP. and its suppliers; a great deal of effort, analysis and selection has gone into creating the Documentation; and copyright and trade secret rights reside in the Documentation. Copyright and all other right, title and interest in the Documentation shall at all times remain with REDX CORP. or its suppliers, as the case may be. REDX CORP. may terminate the Documentation licence granted above immediately on your failure to comply with any term or condition herein or for any other reason in REDX CORP.\'s sole discretion.On expiry of the thirty (30) day Evaluation period, or forthwith upon notice from REDX CORP.that your Evaluation licence to the Documentation is terminated, whichever occurs first, you will permanently erase or otherwise destroy the Documentation together with all copies and upon request from REDX CORP.provide written certification of same to us.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.2.5 General Use Restrictions'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The Site and Content delivered through the Site may not be used:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>In a computer service or timesharing business;</li><li>To create a database in electronic or other format or for the purposes of data dissemination (other than for Internal Business Purposes or archival purposes); or</li><li>For the purposes of commercial resale of the Content in whole or in part or as a derived product based on, or derived from, the Content.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The Site and its Content may not be tampered with through, without limitation, attempts to translate, reverse engineer, decompile, disassemble or modify the Site and the Content except as is expressly permitted herein. You and your Users shall not: sublicence access to the Site and the Content to any third party including the Government of the United States or any regulatory body or agency thereof; export access to the Site and/or Content outside of Canada; or infringe any copyright, patent, trade-mark, trade secret, or other intellectual property right of REDX CORP. and its suppliers.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.2.6 Trademarks'
  },
  {
    variant: 'p',
    component: 'div',
    text: '"REDX" and the "REDX" design mark are trademarks of REDX CORP. Inc. "REDX CORP." is a registered trademark and the "Gateway design" is a trademark of REDX CORP. Inc. Used under license. All rights reserved. Other trademarks or trade names mentioned herein are the trademarks or trade names of their respective owners and are used under license.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.3 TERMINATION AND SUSPENSION'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.3.1 Term'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'This Agreement is effective as of the Effective Date set out in your REDX Application and will automatically renew on each anniversary of the Effective Date unless it is otherwise terminated by you or REDX CORP. on its terms, or upon at least thirty (30) days written notice prior to the end of the then current Subscription Period, by you to REDX CORP., that you do not wish to renew your subscription.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.3.2 Termination by You'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You may terminate this Agreement and/or disable your Subscriber ID(s), User Name(s) and User Password(s) at any time by contacting REDX support. A User may disable its assigned User Name and User Password at any time by contacting REDX support.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.3.3 Termination for Cause by REDX CORP.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'REDX CORP. may terminate this Agreement immediately without notice to you if, in our sole discretion, REDX CORP. believes:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>You and/or a User have failed to comply with any material term or provision hereof including a failure to pay any outstanding amounts;</li><li>You have, or a User of yours has through an act or omission, violated any applicable law or is acting contrary to the interests of REDX CORP.; or</li><li>In the event you become bankrupt or insolvent or make an assignment for the benefit of your creditors or when a receiver is appointed under any instrument or over the assets of, or an order is made or resolution passed for the winding up of the Subscriber.</li>'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.3.4 Termination for Convenience by REDX CORP.'
  },
  {
    variant: 'p',
    component: 'div',
    text: "REDX CORP. may terminate this Agreement at any time: (i) for convenience on 45 calendar day's written notice to you; or (ii) immediately without notice to you in the event that any law or governmental regulation restricts or precludes the collection, use, dissemination or licensing of personal information in the Content."
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.3.5 Suspension by REDX CORP.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'REDX CORP. may suspend the provision of Content made available to you and your Users through this Site under this Agreement immediately without notice to you at any time for non-payment or in the event we believe you or Users have failed to comply with any material term or provision of this Agreement. Suspension may include the suspension of the provision of Content to you and your Users and disablement of Subscriber ID(s), User Name(s) and User Passwords. Suspension by REDX CORP. does not constitute termination of this Agreement and the suspended Subscriber and its User(s), as applicable, shall continue to be bound by the terms of this Agreement during the period of suspension.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.3.6 Effect of Termination'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Termination of this Agreement shall include disablement of all Subscriber IDs, User Name(s) and User Password(s) of you and your User(s).'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.4 SITE AND CONTENT DISCLAIMER'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Unless otherwise expressly provided, the Site and the Content are provided on an "as is" and "as available" basis and without warranties of any kind, either express or implied, statutory or otherwise. To the fullest extent permitted by applicable law, REDX CORP. and the REDX CORP. Group disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose, with respect to the Site, the Content and any website with which the Site is linked. REDX CORP. does not warrant:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>The functions or links contained on the Site or that the Content will meet the requirements of you and your Users;</li><li>That the Site, or the Content, are fit for any particular purpose;</li><li>The operations of the network over which the Site and Content is made available;</li><li>The quality of the Site and Content including but not limited to its completeness, accuracy, correctness and timeliness, reliability, security or otherwise;</li><li>That the Content will be available on an uninterrupted basis;</li><li>That defects in the Site or the Content will be corrected; or</li><li>That the Content or Site or the server(s) that makes the Site and the Content available are free of viruses, worms or other harmful components.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'REDX CORP. does not warrant or make any representations regarding the use of, or the results of the use of, the Site and the Content (including, without limitation, services for the transfer of Content on the Site in terms of its completeness, accuracy, correctness and timeliness, reliability, security or otherwise). REDX CORP. shall not be responsible for any detrimental reliance you and your Users may place on the Site and the Content and use of the Site and Content is strictly at the risk of you and your Users. You (and not REDX CORP.) assume the entire cost to you and your Users of any necessary servicing, repair or correction. Applicable law may not allow the exclusion of implied warranties, so the above exclusion may not apply to you and your Users.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.5 SITE LOCATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The Site is controlled and operated at offices in Toronto, Ontario, Canada. Certain Content and services may be hosted on computers in other jurisdictions. REDX CORP. makes no representation that the Content on the Site is appropriate or available for use in other locations. If you or your Users choose to access this Site and the Content from other locations, you and your Users do so on your and their own initiative and you and your Users are responsible for compliance with local laws, if and to the extent local laws are applicable.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.6 PRODUCTS/SERVICES SUPPLIED FROM OUTSIDE ONTARIO'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You and your Users acknowledge and agree that certain Content available on the Site may be supplied by third parties resident and operating outside the province of Ontario and/or may be hosted on computers located outside of the province of Ontario.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.7 LIMITATION OF LIABILITY'
  },
  {
    variant: 'p',
    component: 'div',
    text: "Under no circumstances, including, but not limited to, negligence, shall REDX CORP. and/or the REDX CORP. Group be liable for any direct, indirect, special, consequential or other damages that result from the use of, or the inability to use, the Site, the Content and/or materials and services accessible through the Site, even if REDX CORP., or a REDX CORP. authorized representative, has been advised of the possibility of such damages. In no event shall REDX CORP.'s liability to you and your Users for all damages, losses, and causes of action (whether in contract, tort, (including but not limited to negligence) or otherwise) exceed the amount paid by you for accessing the Site and Content during the previous twelve(12) months from the date of loss or the claim and, in no event, shall REDX CORP.'s aggregate liability exceed the limits as specified in Section 3.6 below. Applicable law may not allow the limitation or exclusion of liability for incidental or consequential damages, so the above limitation or exclusion may not apply to you and your Users."
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.8 INDEMNIFICATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'To the maximum extent permitted by applicable law, you will defend, indemnify and hold REDX CORP. and the REDX CORP. Group, their suppliers, and their officers, directors, agents and servants harmless from and against all claims, liability, and expenses, including all legal fees and costs, arising out of: (a) a breach of any provision of this Agreement by you and your Users; and (b) the use of the Site and the Content by you and your Users. REDX CORP. reserves the right, in its sole discretion and at its own expense, to assume the exclusive defence and control of any action, claim or matter otherwise subject to indemnification by you. You and your Users will co-operate as fully as reasonably required in the defence of any claim. No settlement will be agreed without the prior written consent of the indemnitor, which shall not be unreasonably witheld.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.9 LINKS TO THIRD PARTY SITES'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Links on the Site may enable you and your Users to leave the Site and connect directly to linked websites. REDX CORP. is providing these links only as a convenience. Such linked websites are entirely independent of the Site, and shall not be construed as any reflection on, any affiliation with, approval of, or endorsement by REDX CORP. of any such site or entity, or its respective information, publications, products or services. REDX CORP. shall not be responsible for the contents of any website linked to the Site or for any link contained in a linked website.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.10 SUBMISSIONS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'We would like to hear from you and your Users regarding the Site, the Content and our products and services. Please note that if you and your Users send us suggestions, ideas, or other information (collectively, "Submissions"), unfortunately we will not be able to return the Submissions. Once submitted, the Submissions will become the property of REDX CORP. and REDX CORP. shall exclusively own all rights to the Submissions of every kind and nature throughout the universe, now known or hereafter existing, and shall be entitled to unrestricted use of the Submissions for any purpose whatsoever, without compensation to you and your Users. By providing the Submissions, you and your Users assign all copyright in and to the Submissions to REDX CORP. and all authors waive all moral rights in the Submission.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.11 USER PRIVACY AND SECURITY POLICY'
  },
  {
    variant: 'p',
    component: 'span',
    text: 'Use of this Site is subject to the terms of the Privacy Policies accessible on this Site '
  },
  {
    variant: 'el',
    text: <PrivacyPolicyLink dialog={dialog} />
  },
  {
    variant: 'p',
    component: 'span',
    text: '. You and your Users recognise and agree that:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>The Internet is not a secure medium, and neither the privacy of communications, nor visits to this Site, can be guaranteed;</li><li>The nature of Internet communications means that communications may be susceptible to data corruption, unauthorised access, interception and delays and the Site may include incomplete information, inaccuracies or typographical errors; and</li><li>REDX CORP. and any other persons involved in the management of the Site may make changes in the Site and Content at any time without notice.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Use of this Site is also subject to the terms of the Security Policy accessible on this Site here. You and your Users recognise and agree that although REDX CORP. security efforts are generally consistent with industry practice in Canada, complete privacy, confidentiality and security associated with any communications is not yet possible over the Internet, and therefore cannot be guaranteed. As a result, REDX CORP. shall not be responsible or liable for any loss of privacy, disclosure of information, harm, damage or loss that may result from the transmission of any information in any connection with the Site.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You and your Users must not attempt to violate the security of the Site, including without limitation:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: "<li>Attempting to log into an account or server which you and your Users are not authorized to access; or</li><li>Attempting to interfere with the services provided by the Site through means of a virus or flooding or otherwise overloading the Site's servers, or by any other similar or dissimilar means.</li>"
  },
  {
    variant: 'p',
    component: 'div',
    text: 'REDX CORP. records activity and all transactions on the Site for the purposes of administration of the Site and the Content contained therein.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.12 PAYMENT FOR ACCOUNTS, PRODUCTS AND/OR SERVICES'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.1 Charges'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Charges and fees for accessing, browsing and using the Site and the Content will be at the rates established by REDX CORP. and its suppliers from time to time (the "Fees"). Charges and Fees do not include applicable taxes in effect from time to time. The Fees payable by you for access to and use of the Site, certain Content and other REDX Services by Users and payment methods may be set out in the REDX Application, the Pricing, sent by email or facsimile to you or posted on the Site.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.2 Changes in Charges'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'In the event that Fees and taxes imposed by third parties change (including without limitation any statutory fee imposed by a government authority), such Fees and taxes shall be changed immediately on notice to you. All other Fees may be changed on 30 calendar days notice to you.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.3 Types of Fees'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Fees may include but are not limited to the following:'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '1.12.3.1 Set-up Fee'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The REDX Service Set-up Fee is a one time fee to establish a REDX Account (the "Set-up Fee"). A separate Set-up Fee is payable for each REDX Account and you may have multiple REDX Accounts. If this Agreement is terminated and you complete a new REDX Application to set up a new REDX Account, a new Set-up Fee will be payable unless stated otherwise in the REDX Application. Payment of a Set-up Fee must be tendered with your completed REDX Application for a REDX Account and is not prorated or refundable.'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '1.12.3.2 Account Maintenance Fees'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Account Maintenance Fees are fees payable for Account maintenance, such as changing Users, setting up new sub-accounts under an Account and changing Users\' levels of access ("Account Maintenance Fees").'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '1.12.3.3 Subscription Fees'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The Subscription Fee is a periodic fee for access to and use of the Site and certain Content by you and your Users (the "Subscription Fee") under an Account for a defined period of time as set out in the REDX Application (the "Subscription Period"). A Subscription Fee for an account is payable by a single payment by cheque or credit card on the Effective Date, and its subsequent anniversaries, and unless stated otherwise in the REDX Application, must be tendered with your completed REDX Application.'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '1.12.3.4 Transaction Fees'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'A Transaction Fee for accessing and using certain Content may become payable at the time a transaction is performed by you or a User ("Transaction Fee"). Transactions that give rise to Fees will be set out in the Pricing, as amended from time to time.'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '1.12.3.5 Additional Fees'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'From time to time we may institute other Fees to cover services such as custom services, investigation services, special invoicing and off-line searching ("Additional Fees"). Any such Additional Fees may be set out in the Pricing or in statements of work.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.4 Payment Methods'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'If payment is made by cheque, you shall deliver cheques payable in the required amounts to REDX CORP. If payment is made by credit card, you will be asked to provide credit card information as part of your REDX Application or as you and your Users use certain Content that generate a Transaction Fee. Payment methods may vary depending on which Content is accessed, browsed or used. Payment methods for various Fees may be set out in the REDX Application and/or posted on the Site together with changes thereto. Payment methods specific to you will be set out in you REDX Application and may be changed by us on notice to you or your User by posting the changes on the Site and/or by giving you notice by email or facsimile.'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '1.12.4.1 Prorating'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Where Fees payable on a periodic basis are incurred part of the way through a Subscription Period, such periodic Fees shall be prorated from the date REDX CORP. advises you that the change has been approved up to and including to the expiration of the applicable Subscription Period.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.5 Fees Payable on Invoicing'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Fees for some of the Content on the Site may be invoiced on a monthly basis. Each commitment of transaction online for such Content for which a Transaction Fee is charged is deemed to be an authorization to invoice sums representing applicable statutory Fees, Transaction Fees, charges, and applicable taxes. Invoices are prepared monthly within 45 days of month end for transactions which occurred in that month. In the event the Agreement is terminated, REDX CORP. shall render a final statement of Fees, taxes and any other charges that are outstanding. All amounts payable to REDX CORP. under this Agreement shall be due and payable thirty (30) days from the invoice date unless expressly set otherwise in an invoice or REDX Application.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.6 Refund Policy'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Before submitting any request for Content, please verify that the name and other information have been entered correctly. We cannot refund the cost of a product or service if the request has been inputted incorrectly. You understand that we will not give a refund where use of REDX Services does not return information on persons or entities who are the subject of your inquiries ("Database Subjects"). Once Fees or taxes are paid or a transaction is committed, there are NO REFUNDS, EXCHANGES OR CANCELLATIONS except as follows:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>If this Agreement is terminated in its entirety by REDX CORP.as set out in Section 1.3.4 above, you shall receive a pro-rata refund of any unused prepaid Fees and applicable taxes; or</li><li>If any attempted use of REDX Service by you or your Users fails through a fault of the Site, a REDX Service or our facilities, our sole liability, at your written request, shall be to refund the Fees and applicable taxes imposed by us for the failed use of REDX Service to: (i) the Subscriber, if payment was by cheque; or (ii) to the holder of the credit card, if a credit card was used for payment. This section shall apply whether or not the liability results from negligence, a breach of a fundamental term or condition, or a fundamental breach of this Agreement. You are responsible for notifying REDX CORP. of the failed use of the REDX Service within 30 days of the failed transaction. After any such 30 day period, you, your Users and the holder of a credit card tendered for payment shall forfeit any recourse to REDX CORP. to claim a refund.</li>'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.12.7 Obligation to Pay and Interest'
  },
  {
    variant: 'p',
    component: 'div',
    text: "You are responsible for all Fees and taxes incurred by you and your Users. Payment obligations for Fees and applicable taxes are material terms of this Agreement. Failure to render payment when due and payable may, at our sole discretion and without limiting any other rights available hereunder, result in all amounts owing, including remaining monthly payments, becoming immediately due and payable or your and your Users' access to the Site and the Content being terminated.If we are unable for any reason to collect the charges, fees and/ or taxes from a cheque tendered as payment, you are responsible to pay us directly the Fees and taxes incurred by you and your Users plus any other charges(including bank charges and the costs of collection) incurred by us.Outstanding Fees and taxes will be subject to a one percent per month interest charge after 30 days calculated on a monthly basis(an effective annual rate of 12.7 %)."
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.13 JURISDICTION AND SEVERABILITY'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You and your Users agree and acknowledge that use of this Site and the Content shall be deemed to have occurred and taken place solely in the Province of Ontario, Canada. You and your Users further agree and acknowledge that this Agreement, and any disputes in connection with use of this Site or its Content, will be governed by the laws of the Province of Ontario, Canada, and the laws of Canada applicable therein. You and your Users expressly consent to the exclusive forum, jurisdiction, and venue of the courts of Ontario in any and all actions, disputes, or controversies relating hereto. If any provision of this Agreement shall be found to be unlawful, void or unenforceable, then such provision shall be deemed severable therefrom and will not affect the validity and enforceability of any remaining provisions.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.14 AMENDMENTS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'REDX CORP. reserves the right to make changes to the Site, the Content including the products and services and to modify, alter or otherwise update these Legal Terms and Conditions, the REDX Application (excluding Pricing) and the REDX Documentation at any time with or without notice. Where material changes to these Legal Terms and Conditions, as determined solely by REDX CORP., are to be made, REDX CORP. will post on the Site for 90 days prior to the effective date of the change(s) a notice to REDX Subscribers of the pending change and notify you and your Users of the change(s) in writing (either via email to the then current email address of you and your Users, or by mail to the then current mailing address of you and your Users). This notice period will not be required should material changes to these Legal Terms and Conditions be required by law prior to the expiry of a 90 day notice period. You and your Users should review this Site on a regular basis for any changes. Continued use of the Site and/or the Content by you and/or your Users shall constitute acceptance of any such changes.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.15 U.S. GOVERNMENT END USERS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The Software available on this Site is a "Commercial Item," as that term is defined at 48 C.F.R. §2.101, consisting of "Commercial Computer Software" as such term may be used in 48 C.F.R. §12.212 or 48 C.F.R. §27.7202, as applicable. Consistent with 48 C.F.R. §12.212 or 48 C.F.R. §§227.7202-1 through 227.7202-4, as applicable, the Commercial Computer Software is licensed to U.S. Government end Users (i) only as Commercial Items; and (ii) with only those rights as are granted to all other end Users pursuant to the terms and conditions herein.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.16 PRIORITIES'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'These Legal Terms and Conditions shall take priority over all attachments to the Agreement, including the REDX Application, applicable Pricing and the Policy and Procedures Guide(s), except as otherwise expressly set out in these Legal Terms and Conditions or the REDX Application.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.17 NOTICES AND CONTACT INFORMATION'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.17.1 Notice'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Any notice given in accordance with this Agreement shall be in writing and the effective date of any such notice, if mailed, shall be the 10th business day following the date of mailing and if hand delivered, shall be the date of delivery. Notices to REDX CORP. under this Agreement shall be directed to <b>REDX CORP., 100 King Street West, Suite 5700, Toronto, Ontario M5X 1C7</b> to the attention of Customer Care, telephone: (647) 588-7339 with a copy emailed on date of mailing or date of hand delivery to <a href="mailto:support@redx.ca">support@redx.ca</a>.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '1.17.2 REDX Support'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Information on how to contact REDX Customer Support is available on the Site on the <a href="https://www.redx.ca/sign-in.asp">Contact Information page</a>.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.18 SURVIVAL'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'All of the provisions of this Agreement, except for Section 1.2.3 "Software Licence", Section 1.2.4 "Documentation Licence During Evaluation", Section 1.12 "Payment for Subscriptions, Products and Services", Section 1.14 "Amendments", and Section 3.1 "Licence" shall survive termination of this Agreement and you and your Users agree to remain bound by those provisions that survive termination of this Agreement.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '1.19 LANGUAGE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The parties have requested that this Agreement and all documents contemplated hereby be drawn up in English. Les parties aux presents not exigé que cette entente et tous autres documents envisagés par les présentes soient rédigés en anglais.'
  },
  {
    variant: 'h6',
    component: 'div',
    text: '2 ADDITIONAL TERMS AND CONDITIONS FOR THE REDX SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: '2.1 THE REDX SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'This Site provides you and your Users with online remote access to data and information about alleged fraud, misrepresentation and misconduct related to the real estate and mortgage industries in Canada (the "REDX Information") which REDX Information may be viewed on the Site or provided in reports generated through the use of the Site (the "REDX Products"). The "REDX Service" means the REDX Information and REDX Products as made available through the Site and is part of the Site Content. The REDX Service primarily references information from public sources in Canada (“REDX Public Service”). From time to time, the REDX Service may contain data and information provided by REDX CORP. and/or REDX Subscribers (“REDX Non-Public Service”). Access to the REDX Non-Public Service is limited and not guaranteed. REDX CORP. reserves the sole discretion to provide or withhold this service and makes no assurances on its availability. REDX Subscribers should not rely on or expect access to the REDX Non-Public Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'In addition to the REDX Information and the REDX Products, as part of the REDX Service, REDX CORP. will provide you with the REDX Policy and Procedures Guides (there is a separate Guide for the REDX Public Service and for the REDX Non-Public Service) and may provide you with certain other documentation (the "Documentation") under licence. Such Documentation may be downloaded by you or your Users or delivered by us to you in digital and/or hardcopy form.'
  },
  {
    variant: 'h6',
    component: 'div',
    text: '3 REDX SERVICE GENERAL TERMS'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.1 LICENCE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You understand and agree that you are granted a non-exclusive, non-transferable, limited, personal licence for you and your Users to:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>Access the REDX Service and Documentation solely for your Internal Business Purposes for the Subscription Period and any subsequent renewals (subject to termination or suspension as set out in Section 1.3.2 and Section 1.3.3); and</li><li>Use the REDX Information and REDX Products solely for your Internal Business Purposes, subject to termination as set out in Section 1.3.2 and Section 1.3.3, and subject to the additional restrictions set out below.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Each of you and your Users is bound by the terms and conditions of this Agreement.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.2 DOCUMENTATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The REDX Policies and Procedures Guides may be revised at our discretion without prior notice to you other than:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>A notice posted on the Site that the REDX Policies and Procedures Guide (s) has been changed; and</li><li>By delivery of a copy of a new version of the REDX Policies and Procedures Guide(s) or revisions to the then-current REDX Policies and Procedures Guide(s) by email to the email address or by facsimile to the facsimile number or by regular mail to the Business Contact in your REDX Application within a reasonable time period prior to the effective date of any revision.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3 RIGHTS AND RESTRICTIONS'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.1 You may reproduce the Documentation for your Internal Business Purposes only, provided you maintain all copyright and other proprietary notices. Documentation shall only be used by you and your Users.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.2 You and your Users may use the REDX Service and view, request and use REDX Information, REDX Products and Documentation only with respect to those persons or entities with whom you are doing business or contemplating a business transaction.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.3 Only Users designated by you that are in good standing as employees shall access the REDX Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.4 You agree that any and all business decisions you make based in any way upon the REDX Service will be made independently by you without recourse to other REDX Subscribers and Users.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.5 Use by you and your Users of personal information (which is data about an identifiable person such as name, address and financial information) in the REDX Service that appeared in a record or document of a judicial or quasi-judicial body shall relate directly to the purpose for which the information appeared in the record or document of the judicial or quasi-judicial body and is subject to applicable privacy legislation in respect of personal information.'
  },
  {
    variant: 'p',
    component: 'div',
    text: "3.3.6 The REDX Service may be used by you solely as one of the factors in your credit, insurance, purchase, sale, marketing or other business decisions relating to corporations, partnerships, sole proprietorships or other business, government or non-profit entities or such entities' stockholders, directors, partners, proprietors, employees, or contractors in their capacities as such.For greater certainty, you are expressly prohibited from using the REDX Service:"
  },
  {
    variant: 'p',
    component: 'ul',
    text: "<li>In establishing a person's eligibility for credit or insurance to be used primarily for personal, family, or household purposes, employment or licensing;</li><li>To engage in any unfair or deceptive practices;</li><li>In connection with the preparation or publication of any information disseminated to or by the news media;</li><li>In your decisions involving a person in their capacity as a consumer;</li><li>For the purpose of screening prospective employees, borrowers or insureds or for any purpose other than as specifically contemplated by this Agreement; and</li><li>For marketing to a named individual.</li>"
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.7 Unless otherwise stated, the REDX Information, Products and Documentation may not be copied, reproduced, republished, uploaded, posted, transmitted, framed, commercially exploited or distributed in any way or by any means whatsoever, except that you and your Users may use the REDX Information and use and reproduce and extract data from the REDX Products for your Internal Business Purposes, provided you and your Users maintain all confidentiality, copyright and other proprietary notices.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.8 The REDX Service and the REDX Information and REDX Products delivered through this Site, may not be used:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>In a computer service or timesharing business;</li><li>To create a database in electronic or other format or for the purposes of data aggregation or dissemination (otherwise than for your internal archival use); or</li><li>For the purpose of sale, resale or the licensing of the data and information or components thereof contained in the REDX Service.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.9 The REDX Service may not be tampered with through attempts to translate, reverse engineer, decompile, disassemble, modify or merge the REDX Service with any other system.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.3.10 Pursuant to our agreements with our suppliers, you and your Users shall not:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>Sub- license access to the REDX Service to the Government of the United States or any regulatory body or agency thereof;</li ><li>Export your access to the REDX Service outside Canada; or</li><li>Infringe any copyright, patent, trademark or trade secret of our suppliers.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Modification of the REDX Information or REDX Products or use of the REDX Service for any purpose other than your Internal Business Purposes is a violation of copyright and other proprietary rights. Unauthorised access to, reproduction, and/or distribution of the REDX Information, REDX Products or REDX Documentation, or any portion thereof, may result in serious civil and criminal penalties, and will be prosecuted to the maximum extent of the law.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.4 CONFIDENTIALITY'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Except as otherwise expressly provided herein, the REDX Information, REDX Products and Documentation shall be held in strict confidence by you. You shall not:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>Distribute the REDX Information, REDX Products and Documentation to persons other than your Users, directors, officers, employees or legal and financial advisors who have a need to know the content of the REDX Information, REDX Products and Documentation; and</li><li>Intentionally or otherwise, reproduce, disclose or otherwise make accessible the REDX Information, REDX Products and Documentation, in whole or in part, in any manner whatsoever, to any other person other than your Users, directors, officers, employees or legal and financial advisors, except with our prior written consent.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Prior to disclosing REDX Information, REDX Products and Documentation to such persons you shall advise them of its confidential nature, issue appropriate instructions to satisfy the obligations hereunder, and take all reasonable steps to ensure that the receipt and use of such disclosing REDX Information, REDX Products and Documentation is on a confidential basis and subject to this Agreement. The restrictions contained in this paragraph do not apply to any information that:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>Is or has become, information in the public domain without the act or omission of you;</li><li>Is lawfully obtained by you from another person without any restriction as to use and disclosure;</li><li>Was in your possession prior to our provision to you;</li><li>Is, was or will be information derived by you independently of us; or</li><li>You or your Users provided to REDX CORP. as a REDX Non-Public Service Subscriber.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.5 REDX SERVICE DISCLAIMER'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The REDX Service including the REDX Information and REDX Products, is provided "as is" and "as available". We make no representation or warranty that any person or entity referenced in the REDX Service is, in fact, the same person or entity that is the subject of your inquiries. We do not confirm the content or validity of information from such third party public sources which we post to the REDX Service. We do not monitor, review or confirm the validity of data and information posted to this Site provided to us by REDX Subscribers. Each posting expresses the views of either the REDX Subscriber or the public source, and not the views of us or any person or entity associated with this Site. We make no representations or warranties, either express or implied, of any kind with respect to such postings including but not limited to non-infringement, completeness, accuracy, correctness, timeliness, reliability or value, and we are not responsible for the content of such postings. The REDX Public Service is not the official government record and may not necessarily reflect the current status of events referenced in such postings. We cannot, and do not, warrant the quality of the REDX Service including but not limited to non-infringement and its completeness, accuracy, correctness, timeliness, reliability, or security, or the merchantability or fitness for a particular purpose. Due to the number of sources the REDX Service uses and from which REDX Information is derived, there may be delays, omissions or inaccuracies in the REDX Service. You and your Users acknowledge that our suppliers, including other REDX Subscribers, make no warranties, express or implied, with respect to the REDX Service. Notwithstanding anything in these Legal Terms and Conditions, we do not, and neither does any person whose data, documents, database or products are operated or distributed by us, guarantee that the REDX Service is complete and wholly accurate, nor that the REDX Service will function without failure or interruption.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'You understand that by making the REDX Service available to you, we are not making recommendations as to the course of action you may take based on the REDX Service. All risk as to the results and performance of the REDX Service is assumed by you and your Users. You also acknowledge that every business decision represents an assumption of risk and that we, in furnishing the REDX Service, do not and cannot underwrite or assume your risks in any manner whatsoever.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.6 REDX SERVICE LIMITATION OF LIABILITY'
  },
  {
    variant: 'p',
    component: 'div',
    text: "Without limiting the limitations on liability in this Agreement, REDX CORP.'s maximum aggregate liability to you and your Users for any claim whatsoever related to the REDX Service shall not exceed the lesser of: "
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>Ten thousand Canadian dollars (CDN$10,000); or</li><li>The Fees actually paid to us by you and your Users in respect of the REDX Service during the previous 12 months from the date of the loss or claim, excluding charges for products and services provided by persons other than us (including without limitation any statutory fees).</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'This section shall apply whether or not the liability results from negligence, a breach of a fundamental term or condition, or a fundamental breach of this Agreement. You and your Users acknowledge that the REDX Service references information from third parties, and this clause is included for the benefit of and can be relied on by those third parties, including other Subscribers which provide information for posting on the Site.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.7 CHANGES TO REDX SERVICE, INFORMATION SOURCES AND CONTENT'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The REDX Service accessible through this Site may be operated and maintained by persons other than us. The REDX Service references data from third party sources and has information posted to the REDX Service by Subscribers, their designated Users and third parties. We may make changes to the REDX Information at any time. In addition, REDX Subscribers may submit information at any time. Such changes may be made without notice except where notice of changes in the REDX Information are communicated to a Subscriber or User as a result of their use of the REDX Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.8 REDX HOURS OF AVAILABILITY'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The hours of availability for the REDX Service are posted on the Site at the Product Info page and are subject to change without notice.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.9 OTHER SUBSCRIBER AND USER OBLIGATIONS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'During the term of the Agreement, you agree that you:'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.9.1 And your Users shall comply with the applicable REDX Policies and Procedures Guides, as amended and updated from time to time;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.9.2 Shall keep the address, telephone number and facsimile number of the Subscriber and the name, address, telephone number, facsimile number and email address of your Business Contact up to date at all times;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.9.3 Shall keep your list of Users up to date including their names, telephone numbers, facsimile numbers and email addresses and the level of access your Users shall have to the REDX Service;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.9.4 Shall exercise due care and attention in selecting, training, and supervising your Users of the REDX Service;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.9.5 Are solely responsible for ensuring that a subject of searches, inquiries and monitoring carried out by you and your Users through the REDX Service is not confused with similarly named persons or entities; and'
  },
  {
    variant: 'p',
    component: 'div',
    text: "3.9.6 For purposes of Subscriber's indemnity to REDX CORP.and the REDX CORP.Group pursuant to Section 1.8 above, and in order to satisfy any such liability by Subscriber to REDX CORP.and / or the REDX CORP.Group pursuant to this Agreement for any other cause whatsoever, Subscriber agrees to maintain, at all times during the Term of this Agreement, all appropriate liability insurance at coverage levels maintained by other prudent persons in similar industry sectors.Such insurance shall cover Subscriber and REDX CORP.and the REDX CORP.Group but in respect of REDX CORP.and the REDX CORP.Group coverage is required solely with respect to the liability arising out of actions of the Subscriber or its Users who may be liable at law pursuant to the Terms of this Agreement.On REDX CORP.'s written request, Subscriber agrees to provide evidence of Subscriber's compliance with the requirement to maintain such liability insurance, which request REDX CORP.may only make once per year of the Term of this Agreement."
  },
  {
    variant: 'p',
    component: 'div',
    text: 'If this Agreement is terminated by us under Section 3.1.3 or Section 3.1.4 you shall, within ten (10) business days of such termination, return to us or certify that you have destroyed all REDX Products, REDX Information and Documentation and any and all other materials which has been furnished to you by us which are proprietary to us and our suppliers.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.10 SURVIVAL'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The licences granted to you in Section 3.1.2 to use the REDX Information, REDX Products and Documentation, as delivered, shall survive termination of the Agreement under Section 1.3.1 and termination by REDX CORP. for convenience under Section 1.3.4.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '3.11 NOTICE TO THE SUBSCRIBER'
  },
  {
    variant: 'p',
    component: 'div',
    text: "All notices to the Subscriber shall be directed to the attention of the Subscriber's Business Contact set out in the REDX Application at the address, email address or facsimile number set out therein."
  },
  {
    variant: 'h6',
    component: 'div',
    text: '4 REDX PUBLIC SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The following terms and conditions apply to the REDX Public Service and are in addition to, and are not intended to be in substitution for, or in any way in limitation of, the "General Terms for the Use of the Site and Content" or "REDX Service General Terms" set out above.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '4.1 REDX PRODUCTS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The REDX Products available are the results produced through use of the REDX Service. REDX Products include: Monitoring, Single Individual Search, Single Company Search, Batch Search, Registry Management and REDX Incident Reports. Other information, services and products may be added to the Site from time to time by us without notice to you. The following REDX Services, Products and/or access are not available through the REDX Public Service: the REDX Non-Public Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '4.2 DISCLOSURE TO DATABASE SUBJECTS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Notwithstanding the use restrictions in Section 3.3 and the confidentiality restrictions in Section 3.4, if a Database Subject, being a person or entity which believes they are referenced in REDX Public Service, asks you for information regarding such alleged reference, you may advise that person or entity as to the nature of the reference but may not provide a copy of the REDX Incident Report to the Database Subject, except as required by law.'
  },
  {
    variant: 'h6',
    component: 'div',
    text: '5 REDX NON-PUBLIC SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The following terms and conditions apply to the REDX Non-Public Service and are in addition to, and are not intended to be in substitution for, or in any way in limitation of, the "General Terms for the Use of the Site and Content" or "REDX Service General Terms" set out above. The REDX Non-Public Service provides you with access to non-public information (contributed by REDX Subscribers and/or REDX CORP. and referred to as "Incident Reports") and public information in the REDX Public Service, described above.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.1 THE REDX NON-PUBLIC SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The REDX Non-Public Service is available to select, approved mortgage originators, servicers, purchasers, insurers, or other financial services industry entities that have a need for, and are in a position to uncover and report, information on incidents of alleged fraud, material misrepresentation, or serious misconduct related to real property transactions which can form the subject of Incident Reports. Approved REDX Non-Public Subscribers are required to submit information in accordance with the procedures outlined in the Guide on their own experiences with relevant incidents involving existing or new Database Subjects.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.2 REDX NON-PUBLIC SERVICE APPLICATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: "To become a REDX Non-Public Service Subscriber, you must submit a REDX Account Application with Pricing, signed by an authorized officer of the corporation. REDX CORP. will review each submitted application to determine the organization's eligibility for participation in the REDX Non- Public Service in accordance with REDX CORP.'s Subscriber approval policies from time to time."
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.2.1 Denial of Application'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Applications to become a REDX Non-Public Service Subscriber may be denied by REDX CORP. for any of the following reasons including, without limitation:'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '5.2.1.1 That the applicant does not meet the eligibility criteria specified in the REDX Non-Public Service Account Application including that the applicant does not maintain an arms length compliance and/or security department able to uncover and report to the REDX Service relevant incidents of alleged fraud, material misrepresentation or serious misconduct which form the subject of Incident Reports; <br />'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '5.2.1.2 The involvement of the applicant in an investigation by, sanctioned from or litigation with, federal, provincial or industry organizations that regulate or set industry standards; and  <br />'
  },
  {
    variant: 'caption',
    component: 'i',
    text: '5.2.1.3 The involvement of the applicant in past or present business practices or activities that are not reputable, demonstrate insufficient integrity and/or lack of moral character, as determined by REDX CORP. acting reasonably.  <br />'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'An applicant denied REDX Non-Public Service Subscriber status may be eligible to subscribe to the REDX Public Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.3 TERMINATION OR SUSPENSION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'In addition to the reasons for termination of this Agreement by REDX CORP. as specified in Section 1.3 above, your REDX Non-Public Service Agreement may be terminated or suspended by REDX CORP. on the basis of, without limitation:'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.3.1 Your failure to maintain adequate confidentiality of and security over REDX Information; including Incident Reports; and'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.3.2 Your failure to maintain adequately trained staff with demonstrated capacity for responsible participation in REDX Non-Public Service;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.3.3 Repeated submission of Incident Reports which are inaccurate, incomplete or erroneous;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.3.4 Your repeated failure to submit Incident Reports on relevant incidents as required under this Agreement; and'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.3.5 Any other actions by you that affect the accuracy, quality or integrity of the REDX Non-Public Service and/or its operations.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.4 VOLUNTARY TERMINATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'A Subscriber which wishes to voluntarily terminate its REDX Non-Public Subscription shall submit a letter to REDX CORP. stating that the Subscriber intends to terminate its relationship with REDX CORP. pursuant to this Agreement; acknowledging the ongoing responsibilities for proper use of any information that has been obtained from the REDX Service; and acknowledging that REDX CORP. retains the right to use, subject to prudent policies and procedures, any information previously provided by the Subscriber including all Incident Reports. Should a former Subscriber be unwilling or unable to update information the Subscriber has contributed to the REDX Non-Public Service, the REDX Service record will indicate that the contributing organization is no longer a Subscriber as of the termination date of this Agreement and that subsequent events could alter or invalidate the Incident Report being viewed.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.5 RELATIONSHIPS AMONG REDX SUBSCRIBERS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'The operation and use of the REDX Non-Public Service shall not entail any direct contact between or among REDX Subscribers. The Non-Public Service provides reports to other Subscribers without revealing the identity of the submitting Subscriber. No direct contact between or among Subscribers is permitted through the REDX Service. Contact among Subscribers relating to loss mitigation measures involved with a specific loan or a specific set of loans may occur in the ordinary course of business and is not prohibited by this policy as such discussions are outside the scope of the REDX Service. In no event does REDX CORP. provide for, recommend or suggest any discussion between or among Subscribers about future actions that should be taken with respect to any database subject.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.6 USE OF THE REDX NON-PUBLIC SERVICE'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Your use and access to the REDX Non-Public Service is subject to the terms and conditions in Section 1.2 above and also the following conditions namely that:'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.6.1 You and your Users may use the REDX Non-Public Service and view, request and use REDX Information, Products and Documentation only with respect to those persons or entities with whom you are doing business or contemplating a business transaction;'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.6.2 Only Users designated by you that are in good standing who are your employees shall access the REDX Non-Public Service; and'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.6.3 You and your Users agree that any and all business decisions made based in any way upon the REDX Non-Public Service will be made independently by you without recourse to other REDX Subscribers and/or Users.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.7 BLIND METHOD OF SHARING'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Incident Reports submitted by Subscribers, and accepted by REDX CORP. for inclusion in the REDX Non-Public Service, will be made available to other REDX Subscribers without revealing the identity of the submitting Subscriber. Subscribers that receive REDX Information agree to refrain from:'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.7.1 Distributing REDX Incident Reports beyond their Users who have a need to know the Information contained in the Incident Reports (except for disclosure to a corporate officer or corporate legal counsel);'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.7.2 Sharing REDX Incident Reports with other Subscribers or with other parties outside the REDX Service; or'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.7.3 Sharing REDX Incident Reports with Database Subjects.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.8 INCIDENT REPORTS'
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.8.1 COMMITMENT TO ACCURACY'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Each Subscriber represents and warrants to REDX CORP. that, to the best of its knowledge, all information submitted in its Incident Reports, and related modifications, clarifications and additions thereto, to the REDX Non-Public Service is complete, true and accurate in order to ensure that Subscribers exchange accurate information. You agree, as a Subscriber to the REDX Non-Public Service, to take all reasonable steps to ensure that Incident Reports submitted to REDX CORP. are true, accurate and complete. REDX CORP. will take steps to ensure that Incident Reports are accurately reflected in the REDX Non-Public Service but makes no warranty as to the accuracy of information submitted by REDX Non-Public Service Subscribers.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.8.2 INCIDENT REPORT SUBMISSIONS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscribers agree to submit to REDX CORP. Incident Reports that directly relate to incidents of alleged fraud, material misrepresentation or serious misconduct by industry professionals and companies in accordance with the criteria and guidelines in the Guide. Incident Reports shall relate only to factual information obtained through a Subscriber\'s own direct investigations, or through investigations performed by a Subscriber\'s agent. By submitting an Incident Report, a Subscriber confirms that the alleged misrepresentation or misconduct had a material impact on the quality of mortgaged loans, insurance or professional services rendered by professionals or companies in the mortgage and/or real estate industries. Subscriber acknowledges that incidents of alleged fraud or material misrepresentation perpetuated solely by a consumer (such as a borrower) are not to be reported to REDX CORP., except that incidents involving non-consumer borrowers (such as professional investors or "straw borrowers" who receive compensation to submit applications for loans actually going to other, unqualified borrowers) or consumers that are industry professionals (such as real estate agents, appraisers, etc.) are reported to REDX CORP. Subscribers agree to at all times follow the instructions in the REDX Non-Public Service Guide in respect of the preparation, review, modification, updating and all other requirements relating to Incident Reports submitted to REDX CORP.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.8.3 SUBSCRIBER LICENCE TO REDX CORP.'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'By submitting an Incident Report to REDX CORP., Subscriber grants REDX CORP. a non-exclusive, perpetual, royalty-free licence to use the Incident Report(s) in the REDX Non-Public Service and to use the information contained in the Incident Report(s) for purposes of preparing any and all reports which relate, directly or indirectly, to the REDX Service.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.8.4 INCIDENT REPORT UPDATES AND MODIFICATIONS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscribers agree to immediately notify REDX CORP. and submit an updated Incident Report when:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>The incident information a Subscriber has previously submitted is discovered in any way to be incomplete, inaccurate or false;</li><li>The Subscriber receives updated information that it determines materially changes a previously submitted Incident Report; and/or</li><li>Actions taken by a Subscriber materially change a previously submitted Incident Report.</li>'
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.8.5 REDX CORP. REQUESTS FOR CLARIFICATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscriber agrees to immediately respond to all requests from REDX CORP. for clarification in respect of Incident Reports submitted by Subscriber. REDX CORP. will revise original Incident Reports based on updates from Subscribers and will provide the revised report to all active Subscribers who received original reports during the previous two (2) years.'
  },
  {
    variant: 'p',
    component: 'i',
    text: '5.8.6 INFORMATION NOT INCLUDED IN INCIDENT REPORTS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscriber acknowledges that the REDX Non-Public Service does not provide any of the following information to Subscribers:'
  },
  {
    variant: 'p',
    component: 'ul',
    text: '<li>The actions taken or planned by a report- submitting Subscriber concerning the subject of an Incident Report;</li><li>The actions taken or planned by a report-receiving Subscriber concerning the subject of an Incident Report;</li><li>The identity of the report-submitting Subscriber (except in the event of self-reporting);</li><li>The prices, terms or conditions under which a Subscriber does business; or</li><li>Any recommended course of action by a report-receiving Subscriber.</li>'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.9 RELEASES FROM DATABASE SUBJECTS'
  },
  {
    variant: 'p',
    component: 'div',
    text: "REDX CORP. recommends and you agree that, after becoming a REDX Subscriber, and as a business best-practice you should incorporate a release form and use reasonable commercial efforts to have such release forms executed as part of your initial approval and renewal procedures for those parties whose names may be submitted in Incident Reports as Database Subjects to the REDX Non-Public Service. The release form will authorize the Subscriber to submit the parties' names for incorporation in related industry background databases, including the REDX Non- Public Service.By signing the release, the party will also consent to the release of Information by the Subscriber to REDX CORP., and by REDX CORP.to other Subscribers, about incidents of alleged fraud, material misrepresentation and / or serious misconduct which may be included in the REDX Non - Public Service."
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.10 REQUESTS FOR INFORMATION FROM DATABASE SUBJECTS NAMED IN REDX REPORTS'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscribers may disclose to a Database Subject that it is listed in a REDX Incident Report. Should a Subscriber choose to disclose to a Database Subject that the Subscriber has obtained information regarding the Database Subject from the REDX Service, the Subscriber shall:'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.10.1 Indicate to the Database Subject that the Subscriber has received information from the REDX Service about the Database Subject;'
  },
  {
    variant: 'p',
    component: 'div',
    text: "5.10.2 Indicate that the Database Subject can also receive this information by contacting REDX CORP. and providing REDX CORP.'s contact particulars as identified in the Guide; and"
  },
  {
    variant: 'p',
    component: 'div',
    text: "5.10.3 Not, except as required by law, provide a Database Subject with a copy of any REDX Incident Report, without REDX CORP.'s prior written consent."
  },
  {
    variant: 'p',
    component: 'div',
    text: "REDX CORP. will respond to Database Subjects' requests for information in accordance with the procedures specified in the Guide.Where a Database Subject responds by providing a written statement relating to the information contained in the Incident Report, REDX CORP.will add the written statement to the REDX Incident Report in appropriate circumstances as particularized in the Guide."
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.11 NO ADVICE RENDERED'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscribers agree that, by providing Subscriber access to the REDX Non-Public Service, Content, Products and Information, REDX CORP. is not providing advice to Subscribers and their Users regarding decisions to be made or actions to be taken by Subscribers. The existence of REDX Information involving a party with whom Subscribers are doing business, or contemplating doing business, shall not be interpreted as a conclusion by the original source of the information, REDX CORP., its personnel, or anyone else associated with REDX CORP. and the REDX Non-Public Service, that sufficient information exists to cause Subscribers to take specific actions regarding a relationship with that party. After receiving information from the REDX Non-Public Service, Subscribers shall make their own independent decisions as to how that information will be used and what actions, if any, will be taken, subject to the terms and conditions of this Agreement.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.12 INDEMNIFICATION'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'In addition to Subscriber\'s indemnification of REDX CORP.and the REDX CORP.Group pursuant to Section 1.8 "Indemnification" above, Subscriber shall defend, indemnify and hold REDX CORP.and the REDX CORP.Group, their suppliers and their officers, directors, agents and servants harmless from and against all claims, liabilities and expenses, including all legal fees and costs, arising out of third party claims with respect to the accuracy of Incident Reports, or any amendments or corrections to such Incident Reports, submitted to REDX CORP.or in any other way based upon Subscriber\'s Incident Reports posted by REDX CORP. on the REDX Non-Public Service, save and except for all claims, liabilities and expenses, including all legal fees and costs, arising out of third party claims with respect to REDX CORP.™ negligent failure to post, in a timely manner, corrections or amendments to Incident Reports submitted by Subscriber. For further clarity, you and your Users acknowledge that the REDX Non-Public Service references information from you, Users and third parties and that REDX CORP. does not edit the information in REDX Non-Public Reports except as instructed to do so by the report-submitting Subscriber or as indicated in Section 5.10 "Requests for Information from Database Subjects Named in REDX Reports".'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.13 PRIVACY'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'Subscribers agree that all use of REDX Non-Public Service information shall relate directly to the purpose for which the information appeared in the original Incident Report, and is subject to applicable privacy legislation regarding personal information. All use of this Site is subject to the terms of the REDX Non-Public Service Privacy Policy accessible on this Site on the Privacy page. See Section 1.11 above for additional privacy and security policies in respect of the Site.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.14 REDX NON-PUBLIC SERVICE DISCLAIMER'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'For greater certainty, Section 3.5 "REDX Service Disclaimer" above and all other disclaimers contained in this Agreement, apply to the Non-Public Service.'
  },
  {
    variant: 'p',
    component: 'div',
    text: '5.15 LIMITATIONS ON LIABILITY'
  },
  {
    variant: 'p',
    component: 'div',
    text: 'For greater certainty, Section 3.6 "REDX Service Limitation of Liability" and all other limitation of liability provisions in this Agreement, apply to the REDX Non-Public Service.'
  }
]
